module.exports = {
  ACCOUNT: 'account', //Account
  CARD: 'card', //Card
  LOAN: 'loan', //LoanAndMortgage
  MORTGAGE: 'mortgage', //LoanAndMortgage
  DEPOSIT: 'deposit', //Deposit
  FUND: 'fund', //Investment
  PENSIONPLAN: 'pensionplan', //Investment
  SHARES: 'share', //Investment
};
